// extracted by mini-css-extract-plugin
module.exports = {"containerConcepts":"styles_containerConcepts__3oPGZ"};